import React, { useCallback, useMemo } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { splitAt } from 'ramda';

import Augenmobil from 'assets/svg-icons/Augenmobil';
import { FIRST_NAME, useUser, useLoggedIn, useSessionActions } from 'store/session';

import { useNavigationItems, useAmountOfItems } from './hooks';
import DropDown from './DropDown';
import CacheReport from './CacheReport';
import ErrorReport from './ErrorReport';
import AppError from './AppError';
import Notification from './Notification';
import LlmLink from './LlmLink';
import { Container, NavbarItems, NavbarLink, Wrapper, LoginWrap, NavbarExtra, NotificationsContainer } from './styles';

const Navbar = () => {
  const { pathname } = useLocation();
  const navigationItems = useNavigationItems();
  const { logout } = useSessionActions();
  const onLogout = useCallback(() => logout(), [logout]);
  const items = useMemo(
    () =>
      navigationItems.map(({ path, label, regexp }) => ({
        path,
        label,
        disabled: regexp ? regexp.test(pathname) : pathname.includes(path),
      })),
    [navigationItems, pathname]
  );

  const amountOfMainItems = useAmountOfItems();
  const [mainItems, dropDownItems] = useMemo(
    () => (items.length - amountOfMainItems > 1 ? splitAt(amountOfMainItems, items) : [items, []]),
    [amountOfMainItems, items]
  );

  const isLoggedIn = useLoggedIn();
  const fullName = useUser(FIRST_NAME);

  return (
    <>
      <Container>
        <Link to="/">
          <Augenmobil />
        </Link>
        {isLoggedIn ? (
          <NavbarItems>
            <Wrapper>
              {mainItems.map(({ path, label, disabled }) => (
                <NavbarLink key={path} to={path} disabled={disabled}>
                  {label}
                </NavbarLink>
              ))}
              <DropDown items={dropDownItems} />
            </Wrapper>
            <LoginWrap>
              {fullName ? (
                <NavbarLink disabled={pathname.includes('/profile')} to="/profile">
                  {fullName}
                </NavbarLink>
              ) : (
                <div />
              )}
              <NavbarLink onClick={onLogout} to={pathname}>
                Abmelden
              </NavbarLink>
            </LoginWrap>
          </NavbarItems>
        ) : (
          <div />
        )}
        <NavbarExtra>
          {isLoggedIn && <CacheReport />}
          <ErrorReport />
          <LlmLink />
        </NavbarExtra>
      </Container>
      <NotificationsContainer>
        <AppError />
        <Notification />
      </NotificationsContainer>
    </>
  );
};

export default Navbar;
